import { useSettings } from '../components/SettingsContext';
import { readEnvString } from '../lib/env';
import { sanitizeApiBase, warnIfUnsafeApiBase } from '../lib/apiBase';

export function useApiBase(): string {
  const { settings } = useSettings();
  const override = sanitizeApiBase(settings.apiBaseOverride);
  if (override) {
    warnIfUnsafeApiBase(override, 'settings.apiBaseOverride');
    return override;
  }

  const envBase = sanitizeApiBase(readEnvString('VITE_API_BASE'));
  if (envBase) {
    warnIfUnsafeApiBase(envBase, 'env.VITE_API_BASE');
    return envBase;
  }

  // Default to same-origin proxy (/api) by returning an empty base so callers build "/api/..."
  return '';
}
